<template>

  <div>
    <div class="form-row">
      <span class="form-label">商标注册证：</span>
      <div class="form-input-box">
        <el-input v-model="value.trademark" placeholder="请输入商标注册编号"></el-input>
      </div>
    </div>

    <div class="form-row">
      <div class="upload-wrap">
        <div class="upload-module">
          <span class="upload-label">上传品牌授权书：</span>
          <div class="upload-box">
            <img v-if="value.trademark_image.length > 0"
                 :src="BASE_URL + value.trademark_image" class="upload-img">
            <img v-else src="../assets/upload-5.png" class="upload-img">
            <input type="file" @change="uploadImage($event, 'trademark_image')" />
          </div>
        </div>
      </div>
    </div>

    <div class="btn-box">
      <button type="button" class="border-btn" @click="prev()">上一步</button>
      <button type="button" @click="next()">提交审核</button>
    </div>
  </div>

</template>

<script>

import {uploadFile} from "@/common/service";
import {BASE_URL} from "@/common/config";

export default {
  name: 'entry-verification-number-step-3',
  model: {
    prop: "params",
    event: "params"
  },
  props: {
    params: {
      default: {
        // 加盟商性质
        nature: '企业',
        // 公司名称
        corporate: '',
        // 社会信用代码
        credit_code: '',
        // 商品授权证书编码
        trademark: '',
        // 营业执照
        business_image: '',
        // logo
        logo_image: '',
        // 商品授权证书
        trademark_image: '',
      },
    },
  },
  computed: {
    value: {
      get() {
        return this.params;
      },
      set(val) {
        this.$emit("params", val);
      }
    },
  },
  data() {
    return {
      BASE_URL,
    };
  },
  mounted() {
  },
  methods: {
    prev() {
      this.$emit('prev', this.value);
    },
    next() {
      this.$emit('next', this.value);
    },
    uploadImage(e, key) {
      const file = e.target.files[0];
      if (!!file) {
        uploadFile(file).then(({data}) => {
          this.params[key] = data.pic_path;
        });
      }
    },
  },
}
</script>

<style scoped>

.form-row {
  width: 352px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
}

.form-label {
  width: 83px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 5px;
  box-sizing: border-box;
}

.form-input-box {
  flex: 1;

}

.form {
  width: 707px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
}

>>>.el-input__inner {
  border-radius: 8px !important;
  border: 1px solid #666666 !important;
  color: #606266 !important;
  height: 30px !important;
  line-height: 30px !important;
}

>>>.el-input__inner::placeholder {
  color: #999999 !important;
}
.get-code-btn {
  color: #FFFFFF;
  font-size: 16px;
  width: 112px;
  height: 30px;
  line-height: 30px;
  background-color: #FF6619;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
}
.btn-box {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.btn-box>button {
  width: 152px;
  height: 36px;
  line-height: 36px;
  background-color: #FF6619;
  border-radius: 8px;
  color: #FFFFFF;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
  box-sizing: border-box;
}

.btn-box>button:last-child {
  margin-right: 0;
}

.btn-box>button.border-btn {
  border: 1px solid #666666;
  color: #666666;
  background-color: #EEEEEE;
}
.upload-wrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.upload-module {
  display: flex;
  align-items: flex-start;
  margin-right: 60px;
}

.upload-module:last-child {
  margin-right: 0;
}

.upload-label {
  width: 146px;
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  padding-right: 18px;
  box-sizing: border-box;
}

.upload-box {
  width: 125px;
  height: 167px;
  position: relative;
}

.upload-box input[type="file"] {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.upload-img {
  width: 100%;
  height: 100%;
}
</style>
